class ComplementaryProducts extends HTMLElement {
    constructor() {
        super();
        this.productId = this.getAttribute('recommendation-product-id');
        this.recommendationType = this.getAttribute('recommendation-type');
        this.recommendationSectionName = this.getAttribute(
            'recommendation-section'
        );
        // Check if productRecommendations are loaded and use it in condition to prevent re-render of product
        this.didProductRecommendationLoad = false;
        this.elObj = {
            recommendationEl: '[products-data]',
            recommendationTitle: '[title]',
            productList: '[data-complementary-products-list]',
            productListToggle: '[data-complementary-products-toggle]',
        };
        // Listen for event when component is in view
        this.addEventListener('observe:elementInView', () => {
            if (this.didProductRecommendationLoad) return;
            this.fetchData();
        });
    } 

    queryHTMLData(htmlString, elementToQuery) {
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        return html.querySelector(elementToQuery).innerHTML;
    }

    renderTitle() {
        const getSectionTitle =
            this.querySelector('template').content.firstElementChild.cloneNode(
                true
            );

        this.prepend(getSectionTitle);
    }

    showProductLayout() {
        this.classList.remove('recommendation-inactive');
    }

    initProductListToggle() {
        const productList = this.querySelector(this.elObj.productList);
        const toggleButton = this.querySelector(this.elObj.productListToggle);
        if (!productList || !toggleButton) return;

        const minItemHeight = 112;
        // Update measured heights so max-height can animate between states.
        const updateListHeight = () => {
            const firstItem = productList.querySelector(
                '.recommendation__vertical-item'
            );
            const firstItemHeight = firstItem?.getBoundingClientRect().height;
            if (firstItemHeight && firstItemHeight >= minItemHeight) {
                productList.style.setProperty(
                    '--recommendation-item-height',
                    `${firstItemHeight}px`
                );
            }
            productList.style.setProperty(
                '--recommendation-expanded-height',
                `${productList.scrollHeight}px`
            );
        };

        requestAnimationFrame(updateListHeight);
        productList.querySelectorAll('img').forEach((image) => {
            if (image.complete) return;
            image.addEventListener('load', updateListHeight, { once: true });
        });
        window.addEventListener('load', updateListHeight, { once: true });

        toggleButton.addEventListener('click', () => {
            updateListHeight();
            const isExpanded = productList.classList.toggle('is-expanded');
            toggleButton.classList.toggle('is-expanded', isExpanded);
            toggleButton.setAttribute('aria-expanded', isExpanded.toString());
            toggleButton.setAttribute(
                'aria-label',
                isExpanded ? 'Collapse products' : 'View more products'
            );
        });
    }

    generateProductLayouts(textData) {
        const returnedHTMLAfterQuery = this.queryHTMLData(
            textData,
            this.elObj.recommendationEl
        );
        if (returnedHTMLAfterQuery && returnedHTMLAfterQuery.trim()) {
            try {
                const elToAppendData = this.querySelector(
                    this.elObj.recommendationEl
                );
                elToAppendData.innerHTML = returnedHTMLAfterQuery;
                this.renderTitle();
                this.showProductLayout();
                this.initProductListToggle();
            } catch (error) {
                console.log(error);
            }
        }
    }

    fetchData() {
        this.didProductRecommendationLoad = true;
        HELPER_UTIL.fetchData({
            method: 'GET',
            responseType: 'text',
            url: `${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&section_id=${this.recommendationSectionName}&intent=${this.recommendationType}`,
            onsuccess: (textData) => {
                this.generateProductLayouts(textData);
                // this.setProductsContainer().active();
            },
            onerror: (error) => {
                console.log(error);
            },
        });
    }

    connectedCallback() {
        console.log('Complementary products connected');
    }
}

customElements.get('complementary-product') ||
    customElements.define('complementary-product', ComplementaryProducts);
